import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import baseUrl from "../url/baseUrl";
import CircleLoader from "react-spinners/CircleLoader";
import "./NewsOnHomePage.css";

const NewsOnHomePage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function fetchNewsData() {
      try {
        const response = await fetch(baseUrl + "/home-news");

        if (response.status !== 200) {
          throw new Error("Something went wrong.");
        }

        const newsList = await response.json();
        setNews(newsList);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
    }

    fetchNewsData();
  }, []);

  return (
    <Fragment>
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <CircleLoader color="#36d7b7" size={50} />
        </div>
      )}
      {news.length !== 0 && (
        <section className="border-bottom mb-4 mt-5">
          <p className="text-uppercase text-center mb-3 text-success">
            Tin tức nổi bật
          </p>
          <div className="scrollable-container d-flex flex-nowrap gap-3">
            {news.map((item, i) => (
              <div
                className="card flex-shrink-0 col-10 col-md-6 col-lg-4"
                key={i}
              >
                <img
                  src={item.imageAvatar}
                  alt={item.title}
                  className="card-img-top"
                />
                <div className="text-dark bg-light">
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-text">{item.shortDesc}</p>
                    <Link to={`/news/${item._id}`} className="btn btn-danger">
                      Chi tiết
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default NewsOnHomePage;
